import React, { useState } from 'react'
import { createUseStyles } from 'react-jss'
import axios from 'axios'
import FormLayoutHalf from '../Form/FormLayoutHalf'
import FormLayoutFull from '../Form/FormLayoutFull'
import Spacer from '../Common/Spacer'
import Button from '../Button'

const PartnerForm = props => {
  const { title } = props
  const classes = useStyles()
  const [formSubmitting, setFormSubmitting] = useState(false)

  const submitForm = e => {
    e.preventDefault()

    const formdata = {
      companyname: e.target.companyname.value,
      type: e.target.type.value,
      iatacode: e.target.iatacode.value,
      companyaddress: e.target.companyaddress.value,
      contactemail: e.target.contactemail.value,
      contactname: e.target.contactname.value,
      contactphone: e.target.contactphone.value,
      contacttitle: e.target.contacttitle.value,
      estimatedbookings: e.target.estimatedbookings.value,
      destinationsoldAU: e.target.destinationsoldAU.checked ? 'Yes' : 'No',
      destinationsoldNZ: e.target.destinationsoldNZ.checked ? 'Yes' : 'No',
      destinationsoldEurope: e.target.destinationsoldEurope.checked ? 'Yes' : 'No',
      destinationsoldCanadaUsa: e.target.destinationsoldCanadaUsa.checked ? 'Yes' : 'No',
      destinationsoldOther: e.target.destinationsoldOther.checked ? 'Yes' : 'No',
    }

    if (
      !e.target.destinationsoldAU.checked &&
      !e.target.destinationsoldNZ.checked &&
      !e.target.destinationsoldEurope.checked &&
      !e.target.destinationsoldCanadaUsa.checked &&
      !e.target.destinationsoldOther.checked
    ) {
      alert('Please select at least one destination sold.')
      return
    }

    setFormSubmitting(true)
    const params = new FormData()
    for (const key in formdata) {
      params.append(key, formdata[key])
    }

    axios
      .post('/api/partner-register', params)
      .then(function({ data }) {
        setFormSubmitting(false)
        if (data.status !== true) {
          alert(data.message)
          return
        }
        alert(
          'Thank you for your interest in becoming a partner with us. We will be in touch shortly.',
        )
      })
      .catch(function(error) {
        console.log(error)
      })

    console.log('submitForm', formdata)
  }

  return (
    <div className={classes.container}>
      <form onSubmit={submitForm}>
        <div className={classes.title}>{title || 'TRAVEL PARTNER APPLICATION FORM'}</div>
        <FormLayoutFull>
          <div className={classes.label}>Company name*</div>
          <input className={classes.input} name="companyname" type="text" required />
        </FormLayoutFull>
        <Spacer desktopHeight={20} />
        <FormLayoutHalf
          leftHalf={
            <>
              <div className={classes.label}>Type</div>
              <select className={classes.select} name="type" required>
                <option value="">Please Select</option>
                <option>Travel Agent</option>
                <option>Accommodation Provider</option>
                <option>Tour Operator</option>
              </select>
            </>
          }
          rightHalf={
            <>
              <div className={classes.label}>IATA Code*</div>
              <input className={classes.input} name="iatacode" type="text" required />
            </>
          }
        />
        <Spacer desktopHeight={20} />
        <FormLayoutFull>
          <div className={classes.label}>Company Address</div>
          <textarea className={classes.input} name="companyaddress" rows={5} required></textarea>
        </FormLayoutFull>
        <Spacer desktopHeight={20} />
        <FormLayoutHalf
          leftHalf={
            <>
              <div className={classes.label}>Contact Email*</div>
              <input className={classes.input} name="contactemail" type="email" required />
            </>
          }
          rightHalf={
            <>
              <div className={classes.label}>Contact Number*</div>
              <input className={classes.input} name="contactphone" type="tel" required />
            </>
          }
        />
        <Spacer desktopHeight={20} />
        <FormLayoutHalf
          leftHalf={
            <>
              <div className={classes.label}>Contact Name*</div>
              <input className={classes.input} name="contactname" type="text" required />
            </>
          }
          rightHalf={
            <>
              <div className={classes.label}>Contact Position*</div>
              <input className={classes.input} name="contacttitle" type="text" required />
            </>
          }
        />
        <Spacer desktopHeight={20} />
        <FormLayoutHalf
          leftHalf={
            <>
              <div className={classes.label}>Estimated Bookings*</div>
              <input className={classes.input} name="estimatedbookings" type="text" required />
            </>
          }
          rightHalf={
            <>
              <div className={classes.label}>Destination sold*</div>
              <ul className={classes.checkboxList}>
                <li>
                  <label>
                    <input type="checkbox" name="destinationsoldAU" value="AU" /> <span>AU</span>
                  </label>
                </li>
                <li>
                  <label>
                    <input type="checkbox" name="destinationsoldNZ" value="NZ" /> <span>NZ</span>
                  </label>
                </li>
                <li>
                  <label>
                    <input type="checkbox" name="destinationsoldEurope" value="Europe" />{' '}
                    <span>Europe</span>
                  </label>
                </li>
                <li>
                  <label>
                    <input type="checkbox" name="destinationsoldCanadaUsa" value="Canada/USA" />{' '}
                    <span>Canada/USA</span>
                  </label>
                </li>
                <li>
                  <label>
                    <input type="checkbox" name="destinationsoldOther" value="Other" />{' '}
                    <span>Other</span>
                  </label>
                </li>
              </ul>
            </>
          }
        />
        <Spacer desktopHeight={20} />
        <Button type="submit" fluid={false} disabled={formSubmitting}>
          {formSubmitting ? 'Processing...' : 'Submit'}
        </Button>
      </form>
    </div>
  )
}

const useStyles = createUseStyles(theme => ({
  container: {
    paddingTop: 30,
    paddingBottom: 30,
    '@media (max-width: 679px)': {
      width: '100%',
    },
  },
  title: {
    fontSize: '1.5rem',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: '30px',
  },
  label: {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  input: {
    boxSizing: 'border-box',
    width: '100%',
    borderRadius: 2,
    border: '1px solid #bbb',
    padding: '10px 12px',
    resize: 'none',
    fontSize: '1rem',
  },
  select: {
    appearance: 'none',
    boxSizing: 'border-box',
    width: '100%',
    borderRadius: 2,
    border: '1px solid #bbb',
    padding: '10px 12px',
    fontSize: '1rem',
    backgroundImage:
      'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 50%',
  },
  checkboxList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& li': {
      marginBottom: '10px',
      listStyle: 'none',
      '& label': {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        cursor: 'pointer',
      },
    },
  },
}))

export default PartnerForm
